module.exports = __webpack_public_path__ + "img/oab.208a5843.png";